import { Factory } from '../../services/Factory';

namespace app.controllers.authentication {

  export class ResetPasswordController {
    constructor($scope, $route, $http, $routeParams, $location, configService: app.services.IConfigService, tokenService: app.services.authentication.TokenService, stateService: app.services.state.StateService, accountService: app.services.account.AccountService, notificationService: app.services.INotificationService, $uibModal) {

      $scope.resetInProgress = false;
      $scope.account = {};

      // currently selected route.
      $scope.isReset = $route.current.action == "reset";
      $scope.isVerify = $route.current.action == "verify";

      if ($scope.isVerify) {
        notificationService.addSuccess({
          title: "Email address verified!",
          description: "Now just enter your password and log in",
          timeout: 5000
        });
      }

      $scope.handleResetPassword = form => {
        const data: any = _.pick(form, "password");

        data.email = $routeParams.email;
        data.accountId = $routeParams.accountId;
        data.token = $routeParams.passwordResetToken;

        $http.post(`${configService.getServerBaseUrl()}/account/reset`, data).success(function (data, status) {
          // $scope.resetInProgress = false;

          notificationService.addSuccess({
            title: "Password Reset",
            description: "Please log in with your new password",
            timeout: 5000
          });

          $location.path('/');

        }).error(function (data, status) {
          $scope.resetInProgress = false;
        });

        console.log(data);
      };
    }
  }

  frontendApp.controller("ResetPasswordController", ["$scope", "$route", "$http", "$routeParams", "$location", "ConfigService", "TokenService", "StateService", "AccountService", "NotificationService", "$uibModal", Factory.Create(ResetPasswordController)]);
}
